document.addEventListener("DOMContentLoaded", () => {
  const lookDrawerPopovers = document.querySelectorAll(".look-drawer__popover");

  lookDrawerPopovers.forEach((lookDrawerPopover) => {
    // Listen for clicks on buttons with the class "popover__value-option"
    lookDrawerPopover.addEventListener("click", (event) => {
      const target = event.target;

      // Check if the clicked element is a "popover__value-option" button
      if (target && target.classList.contains("popover__value-option")) {
        const selectedVariantId = target.getAttribute("variant-id");
        const selectedSize = target.value;

        // Find the parent "look-item__sizes" container
        const popover = target.closest("x-popover");
        const popoverID = popover.id;

        if (popoverID) {
          // Update the "selected-size" button text
          const selectedSizeButton = document.querySelector("[aria-controls="+popoverID+"]");
          if (selectedSizeButton) {
            selectedSizeButton.querySelector('.size-name').textContent = selectedSize;
            selectedSizeButton.setAttribute("selected-variant-id", selectedVariantId);
            selectedSizeButton.setAttribute("aria-expanded", false);
          } else {
            console.log("Selected-size button not found.");
          }

          // Close the popup
          if (popover) {
            popover.setAttribute("aria-expanded", "false");
            popover.removeAttribute("open");
            popover.style.display = "none"; // Hide the popup
          } else {
            console.log("Popover not found.");
          }
        } else {
          console.log("Sizes container not found.");
        }
      }
    });
  })

    const lookDrawer = document.querySelector(".look-drawer");

    if (lookDrawer) {
      // Function to update the submit button state
      const updateSubmitButtonState = () => {
        const checkboxes = lookDrawer.querySelectorAll('.look-drawer__items:not(.hidden) input[name="look-item"]:checked');
        const footerEl = lookDrawer.querySelector('.look-drawer__items:not(.hidden)');
        const submitButton = footerEl.nextElementSibling.querySelector('.button[type="submit"]')

        // Get the toggle text from hidden HTML elements
        const chooseProductText = lookDrawer.querySelector('[data-choose-product-text]').dataset.chooseProductText;
        const addToCartText = lookDrawer.querySelector('[data-add-to-cart-text]').dataset.addToCartText;
        if (checkboxes.length === 0) {
          // No checkboxes are checked, disable the button and show "Sold Out" text
          submitButton.disabled = true;
          submitButton.textContent = chooseProductText;
        } else {
          // At least one checkbox is checked, enable the button and show "Add to Cart" text
          submitButton.disabled = false;
          submitButton.textContent = addToCartText;
        }
      };

      // Function to update the total price
      const updateTotalPrice = () => {
        const visibleItems = lookDrawer.querySelectorAll('.look-drawer__items:not(.hidden) .look-drawer__item input[name="look-item"]:checked');
        let totalPrice = 0;

        visibleItems.forEach((item) => {
          const parentItem = item.closest('.look-drawer__item');
          if (parentItem) {
            const itemPrice = parseFloat(parentItem.dataset.price) || 0;
            totalPrice += itemPrice;
            console.log("Item price:", itemPrice, "Total price so far:", totalPrice);
          }
        });

        // Update the total price in the span inside the 'look-total_price' element
        const footerEl = lookDrawer.querySelector('.look-drawer__items:not(.hidden)');
        const totalPriceElement = footerEl.nextElementSibling.querySelector('.look-total_price span');
        if (totalPriceElement) {
          totalPrice = totalPrice/100;
          totalPriceElement.textContent = totalPrice.toFixed(2) + '€'; // Format to 2 decimal places
        } else {
          console.log("Total price element not found.");
        }
      };

      // Function to update the count of checked items
      const updateCheckedItemCount = () => {
        const checkedItems = lookDrawer.querySelectorAll('.look-drawer__items:not(.hidden) .look-drawer__item input[name="look-item"]:checked');
        const footerEl = lookDrawer.querySelector('.look-drawer__items:not(.hidden)');
        const itemCountElement = footerEl.nextElementSibling.querySelector('.looks-items-count');

        if (itemCountElement) {
          itemCountElement.textContent = checkedItems.length; // Update the count of checked items
          console.log("Checked items count updated:", checkedItems.length);
        } else {
          console.log("Item count element not found.");
        }
      };

      /**
      * Function to uncheck checkboxes for items that are out of stock
      */
      const uncheckOutOfStockItems = () => {
        const lookDrawer = document.querySelector("look-drawer");

        if (lookDrawer) {
          // Select all items with the 'look-item__sizes' element having the 'out-of-stock' class
          const outOfStockItems = lookDrawer.querySelectorAll('.look-item__sizes.out-of-stock');

          outOfStockItems.forEach((outOfStockItem) => {
            // Find the associated checkbox within the same 'look-drawer__item'
            const parentItem = outOfStockItem.closest('.look-drawer__item');
            if (parentItem) {
              const checkbox = parentItem.querySelector('input[name="look-item"]');
              if (checkbox) {
                checkbox.checked = false; // Uncheck the checkbox
                console.log(`Unchecked checkbox for out-of-stock item with variant ID: ${parentItem.dataset.variantId}`);
              }
            }
          });
        } else {
          console.log("LookDrawer not found.");
        }
      };


      // Add event listeners to all checkboxes
      const checkboxes = lookDrawer.querySelectorAll('input[name="look-item"]');
      checkboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", () => {
          updateSubmitButtonState();
          updateTotalPrice();
          updateCheckedItemCount();
        });
      });

      // Initial state update
      updateSubmitButtonState();
      uncheckOutOfStockItems();
      updateTotalPrice();
      updateCheckedItemCount();
    } else {
      console.log("LookDrawer not found.");
    }
});

